import { useContext, useState } from "react";
import useTranslator from "../../hooks/useTranslator";
import LandLordContext from "../../context/landlord/LandLordContext";
import { Icon, Switch } from "../design";

/** Notifications tab of "Manage workspace": my email preferences. */
const NotificationCustomization = ({
  workspaceMemberInfo,
  memberLoading,
  loadMembersData,
}) => {
  const { _t } = useTranslator();
  const { updateWorkspaceEmailPreference } = useContext(LandLordContext);
  const [toggleLoading, setToggleLoading] = useState(false);

  const handleUpdateUsersPreference = async () => {
    try {
      setToggleLoading(true);
      await updateWorkspaceEmailPreference({
        tenant_signup: !workspaceMemberInfo?.email_settings?.tenant_signup,
      });
      await loadMembersData();
    } catch (error) {
      console.error("Error updating email preference:", error);
    } finally {
      setToggleLoading(false);
    }
  };

  return (
    <div className="workspace-tab-panel">
      <h3 className="workspace-section-title">
        {_t("myEmailPreferencesInThisWorkspace")}
      </h3>
      <p className="workspace-note">
        <Icon name="info" size={18} />
        {_t(
          "inAppNotificationsAreAlwaysOnTheseSettingsOnlyAffectEmailSentToYouForThisWorkspace"
        )}
      </p>
      <Switch
        id="workspace-email-tenant-signup"
        label={_t(
          "applicationEmailsTogglerTitle",
          "Workspace email preferences"
        )}
        description={_t(
          "applicationEmailsTogglerDescription",
          "Workspace email preferences"
        )}
        checked={workspaceMemberInfo?.email_settings?.tenant_signup || false}
        disabled={toggleLoading || memberLoading}
        onChange={handleUpdateUsersPreference}
      />
    </div>
  );
};

export default NotificationCustomization;
